import * as React from 'react';
import styled, { css } from 'styled-components';
import { selectThemeSemantics } from '../../../styling';
import { ActionButton, IButtonProps } from '../../button';
import { Icon } from '../../icon';

export interface ITabHeaderItemActionButtonProps extends IButtonProps {
    tabKey: React.Key;
    buttonColor?: string;
    isActive?: boolean;
    onActionClick?(tabKey: React.Key): void;
}

function TabHeaderItemActionButtonBase(props: ITabHeaderItemActionButtonProps) {
    const { onActionClick, tabKey, ref, elementRef, buttonColor, isActive, ...rest } = props;
    const _onClick = React.useCallback((ev: React.MouseEvent) => {
        ev.stopPropagation();
        if (onActionClick) {
            onActionClick(tabKey);
        }
    }, [onActionClick, tabKey]);

    return (
        <ActionButton {...rest} elementRef={elementRef} onClick={_onClick} />
    );
}

export const TabHeaderItemActionButton = styled(TabHeaderItemActionButtonBase)`
   &,${ActionButton}{
        height: auto;
        &:hover {
            ${Icon} {
                ${({ isActive }) => isActive &&
                    css`fill: ${selectThemeSemantics(({ palette }) => palette.white)}!important; opacity: 0.5`};
            }
        }
    }
    & ${Icon}{
      ${({ buttonColor }) => buttonColor && css`fill: ${buttonColor};`};
    }
`;
